/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Public operation request. It deliberately has no credential or path field.
 */
export type GitHubReadCloneRequest = {
  assignmentGeneration: number;
  repositoryId: number;
  owner: string;
  repository: string;
  baseSha: string;
};

/** @internal */
export const GitHubReadCloneRequest$inboundSchema: z.ZodType<
  GitHubReadCloneRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  assignment_generation: z.number().int(),
  repository_id: z.number().int(),
  owner: z.string(),
  repository: z.string(),
  base_sha: z.string(),
}).transform((v) => {
  return remap$(v, {
    "assignment_generation": "assignmentGeneration",
    "repository_id": "repositoryId",
    "base_sha": "baseSha",
  });
});
/** @internal */
export type GitHubReadCloneRequest$Outbound = {
  assignment_generation: number;
  repository_id: number;
  owner: string;
  repository: string;
  base_sha: string;
};

/** @internal */
export const GitHubReadCloneRequest$outboundSchema: z.ZodType<
  GitHubReadCloneRequest$Outbound,
  z.ZodTypeDef,
  GitHubReadCloneRequest
> = z.object({
  assignmentGeneration: z.number().int(),
  repositoryId: z.number().int(),
  owner: z.string(),
  repository: z.string(),
  baseSha: z.string(),
}).transform((v) => {
  return remap$(v, {
    assignmentGeneration: "assignment_generation",
    repositoryId: "repository_id",
    baseSha: "base_sha",
  });
});

export function gitHubReadCloneRequestToJSON(
  gitHubReadCloneRequest: GitHubReadCloneRequest,
): string {
  return JSON.stringify(
    GitHubReadCloneRequest$outboundSchema.parse(gitHubReadCloneRequest),
  );
}
export function gitHubReadCloneRequestFromJSON(
  jsonString: string,
): SafeParseResult<GitHubReadCloneRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GitHubReadCloneRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GitHubReadCloneRequest' from JSON`,
  );
}
